import { render, staticRenderFns } from "./focus_action.vue?vue&type=template&id=0bc846bc"
import script from "./focus_action.vue?vue&type=script&lang=js"
export * from "./focus_action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports